export default __webpack_public_path__ + "static/media/speer_logo_header_white.ceb3e268.svg";